import { Component, OnInit } from '@angular/core';
import {PortfolioService} from "../../pages/portfolio/portfolio.service";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {CompanyModel} from "../../shared/models/company.model";
import { MaterialModule } from 'src/app/app.materials';
import { FileUploaderComponent } from "../file-uploader/file-uploader.component";
import { UploadResultDialogComponent } from "../upload-result-dialog/upload-result-dialog.component";
@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
  standalone: true,
  imports: [MaterialModule, FileUploaderComponent]
})
export class UploadDialogComponent implements OnInit {
  isUploading = false;

  constructor(
    private service: PortfolioService,
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  handleResponse(resp) {
    let companies = [];
    let notFound = [];
    if (resp.success) {
      if (resp.success.items && resp.success.items.length) {
        companies = resp.success.items.map((i: any) => {
          let weight = resp.success.weights[i.isin];
          i.weight = weight ? weight : 0;
          i.selected = true;
          return new CompanyModel(i);
        })
      }
      notFound = resp.success.not_found || [];
    }
    return {
      companies: companies,
      notFound: notFound
    };
  }

  onUploadEvent(file) {
    if (!file) {
      return this.service.notificationService.open("Error. Missing file.");
    }
    this.isUploading = true;
    const formData = new FormData();
    formData.append('file', file);
    this.service.uploadCSVFile(formData).subscribe((resp: any) => {
      this.isUploading = false;

      const result = this.handleResponse(resp);
      
      // Check if there are any not found ISINs
      if (result.notFound && result.notFound.length > 0) {
        // Show dialog with results
        const resultDialogRef = this.dialog.open(UploadResultDialogComponent, {
          data: {
            successCount: result.companies.length,
            notFound: result.notFound
          },
          maxWidth: '500px',
          disableClose: false
        });

        resultDialogRef.afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.dialogRef.close({ companies: result.companies, notFound: result.notFound });
          }
        });
      } else {
        // All ISINs found, show success message and close
        this.service.notificationService.open(`File uploaded! All ${result.companies.length} companies imported.`);
        this.dialogRef.close({ companies: result.companies, notFound: [] });
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
